import type { SVGProps } from "react";
// generated from ArrowLeft.svg — do not edit manually
// prettier-ignore
export default function ArrowLeft(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
  <path d="M11 5L4 12M4 12L11 19M4 12L20 12" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
